import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";

export const SectionLabel = ({
  label,
  href,
  children,
}: {
  label: string;
  href?: string;
  children?: React.ReactNode;
}) => (
  <div className="flex items-end h-8 mb-3 pb-2 border-b-2 border-foreground/20">
    <h2 className="text-xs font-bold tracking-widest uppercase text-foreground leading-none">{label}</h2>
    {href && (
      <Link
        to={href}
        className="text-[11px] text-primary font-semibold hover:underline underline-offset-4 inline-flex items-center gap-1 ml-3 leading-none"
      >
        More {label} <ArrowRight className="w-3 h-3" aria-hidden="true" />
      </Link>
    )}
    {children && <div className="ml-auto leading-none">{children}</div>}
  </div>
);
